const DataCountEid = (props) => {
    const itemOffset = props.itemOffset;
    const items = props.items;
    const totalRecords = props.totalRecords;
    return(
        <div>
            <p>{`Showing ${itemOffset+1} to ${(itemOffset+10)<items.length ? itemOffset+10 : items.length} of ${totalRecords} entries`}</p>
        </div>
    );
}

export default DataCountEid;
